import { Product } from '@/interfaces/products/shop'
import { Dispatch } from 'redux'
import * as wishListService from '../services/wishList'
import { getWishListProducts } from '../services/products'

export const ACTIONS = {
  GET_WISH_LIST_REQUEST: 'GET_WISH_LIST_REQUEST',
  GET_WISH_LIST_SUCCESS: 'GET_WISH_LIST_SUCCESS',
  GET_WISH_LIST_FAILURE: 'GET_WISH_LIST_FAILURE',
  ADD_TO_WISH_LIST_REQUEST: 'ADD_TO_WISH_LIST_REQUEST',
  ADD_TO_WISH_LIST_SUCCESS: 'ADD_TO_WISH_LIST_SUCCESS',
  ADD_TO_WISH_LIST_FAILURE: 'ADD_TO_WISH_LIST_FAILURE',
  REMOVE_FROM_WISH_LIST_REQUEST: 'REMOVE_FROM_WISH_LIST_REQUEST',
  REMOVE_FROM_WISH_LIST_SUCCESS: 'REMOVE_FROM_WISH_LIST_SUCCESS',
  REMOVE_FROM_WISH_LIST_FAILURE: 'REMOVE_FROM_WISH_LIST_FAILURE',
  RESET_WISH_LIST: 'RESET_WISH_LIST',
  CHECK_WISH_LIST_EXISTENCE: 'CHECK_WISH_LIST_EXISTENCE',
  CHECK_WISH_LIST_EXISTENCE_SUCCESS: 'CHECK_WISH_LIST_EXISTENCE_SUCCESS',
  CHECK_WISH_LIST_EXISTENCE_FAILURE: 'CHECK_WISH_LIST_EXISTENCE_FAILURE',
} as const

const RESET_WISH_LIST = () => ({
  type: ACTIONS.RESET_WISH_LIST,
})

const GET_WISH_LIST_REQUEST = () => ({
  type: ACTIONS.GET_WISH_LIST_REQUEST,
})

const GET_WISH_LIST_SUCCESS = (products: Product[]) => ({
  type: ACTIONS.GET_WISH_LIST_SUCCESS,
  products,
})

const GET_WISH_LIST_FAILURE = (error: Error) => ({
  type: ACTIONS.GET_WISH_LIST_FAILURE,
  error,
})

const ADD_TO_WISH_LIST_REQUEST = () => ({
  type: ACTIONS.ADD_TO_WISH_LIST_REQUEST,
})

const ADD_TO_WISH_LIST_SUCCESS = (id: number) => ({
  type: ACTIONS.ADD_TO_WISH_LIST_SUCCESS,
  id,
})

const ADD_TO_WISH_LIST_FAILURE = (error: Error) => ({
  type: ACTIONS.ADD_TO_WISH_LIST_FAILURE,
  error,
})

const REMOVE_FROM_WISH_LIST_REQUEST = () => ({
  type: ACTIONS.REMOVE_FROM_WISH_LIST_REQUEST,
})

const REMOVE_FROM_WISH_LIST_SUCCESS = (id: number) => ({
  type: ACTIONS.REMOVE_FROM_WISH_LIST_SUCCESS,
  id,
})

const REMOVE_FROM_WISH_LIST_FAILURE = (error: Error) => ({
  type: ACTIONS.REMOVE_FROM_WISH_LIST_FAILURE,
  error,
})

const CHECK_WISH_LIST_EXISTENCE = () => ({
  type: ACTIONS.CHECK_WISH_LIST_EXISTENCE,
})

const CHECK_WISH_LIST_EXISTENCE_SUCCESS = (productIds: {
  [key: string]: boolean
}) => ({
  type: ACTIONS.CHECK_WISH_LIST_EXISTENCE_SUCCESS,
  productIds,
})

const CHECK_WISH_LIST_EXISTENCE_FAILURE = (error: Error) => ({
  type: ACTIONS.CHECK_WISH_LIST_EXISTENCE_FAILURE,
  error,
})

export const getWishList = (page: number, limit: number, locale?: string) => {
  return (dispatch: Dispatch) => {
    dispatch(GET_WISH_LIST_REQUEST())
    return getWishListProducts(page, limit, locale)
      .then((products) => dispatch(GET_WISH_LIST_SUCCESS(products)))
      .catch((error) => dispatch(GET_WISH_LIST_FAILURE(error)))
  }
}

export const addToWishList = (product: Product) => {
  return (dispatch: Dispatch) => {
    dispatch(ADD_TO_WISH_LIST_REQUEST())
    return wishListService
      .addToWishList(product.code)
      .then(() => dispatch(ADD_TO_WISH_LIST_SUCCESS(product.id)))
      .catch((error) => dispatch(ADD_TO_WISH_LIST_FAILURE(error)))
  }
}

export const removeFromWishList = (product: Product) => {
  return (dispatch: Dispatch) => {
    dispatch(REMOVE_FROM_WISH_LIST_REQUEST())
    return wishListService
      .removeFromWishList(product.code)
      .then(() => dispatch(REMOVE_FROM_WISH_LIST_SUCCESS(product.id)))
      .catch((error) => dispatch(REMOVE_FROM_WISH_LIST_FAILURE(error)))
  }
}

export const resetWishList = () => {
  return (dispatch: Dispatch) => {
    dispatch(RESET_WISH_LIST())
  }
}

export const checkWishListExistence = (productIds: number[]) => {
  return (dispatch: Dispatch) => {
    dispatch(CHECK_WISH_LIST_EXISTENCE())
    return wishListService
      .checkWishListExistence(productIds)
      .then((productIds) =>
        dispatch(CHECK_WISH_LIST_EXISTENCE_SUCCESS(productIds))
      )
      .catch((error) => dispatch(CHECK_WISH_LIST_EXISTENCE_FAILURE(error)))
  }
}
